var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFA800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6667 28.9167H33.5M27.6667 33H37M27.6667 40V42.7248C27.6667 43.3464 27.6667 43.6572 27.7941 43.8169C27.9049 43.9557 28.073 44.0365 28.2506 44.0363C28.4549 44.0361 28.6976 43.8419 29.183 43.4536L31.9661 41.2271C32.5346 40.7723 32.8189 40.5449 33.1354 40.3832C33.4162 40.2397 33.7152 40.1349 34.0241 40.0715C34.3723 40 34.7363 40 35.4644 40H38.4C40.3602 40 41.3403 40 42.089 39.6185C42.7475 39.283 43.283 38.7475 43.6185 38.089C44 37.3403 44 36.3602 44 34.4V28.1C44 26.1398 44 25.1597 43.6185 24.411C43.283 23.7525 42.7475 23.217 42.089 22.8815C41.3403 22.5 40.3602 22.5 38.4 22.5H28.6C26.6398 22.5 25.6597 22.5 24.911 22.8815C24.2525 23.217 23.717 23.7525 23.3815 24.411C23 25.1597 23 26.1398 23 28.1V35.3333C23 36.4183 23 36.9608 23.1193 37.4059C23.4429 38.6137 24.3863 39.5571 25.5941 39.8807C26.0392 40 26.5817 40 27.6667 40Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#FEDF89",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService);
export default __webpack_public_path__ + "static/media/Service.ffa2553324c7a9f2a18a1ca8a6db7804.svg";
export { ForwardRef as ReactComponent };